wbApp.controller('AccountingBookCtrl', ['$scope', '$modal', 'accountingBookSvc', '$routeParams', '$location', '$timeout',
function ($scope, $modal, accountingBookSvc, $routeParams, $location, $timeout) {
    
    $scope.filterOptions = {
        filterText: ""
    };

    $scope.gridOptions = {
        sortInfo: { fields: ['name'], directions: ['dsc'] },
        columnDefs: [{ field: 'name', displayName: "TXT_LBL_NAME", sort: 'locale', width: '250px'  },
                     { field: 'subjectName', displayName: "TXT_LBL_SUBJECT_NAME", sort: 'locale', width: '250px' },
                     { field: 'subjectAddress', displayName: "TXT_LBL_ADDRESS", sort: 'locale' },
                     { field: 'organisationIdentifier', displayName: "TXT_LBL_ORGANISATION_IDENTIFIER", align: 'right', width: '110px' },
                     { field: 'accountNo', displayName: "TXT_LBL_ACCOUNT_NO", align: 'right', width: '160px' }
        ]
    };

    $scope.accountingBooks = accountingBookSvc.getAllAsync(true);

    // Open Detail if we have query parameter
    let editDetailAccountingBookId = Number($routeParams.id);
    if (editDetailAccountingBookId) {
        $scope.accountingBooks.$promise.then(function (result) {
            let data = _.find($scope.accountingBooks, { id: editDetailAccountingBookId });
            if (!data) {
                $location.path('/finance/accounting-books');
            } else {
                detailDialogPromise.$promise.then(function () {
                    detailDialogPromise.$scope.model = angular.copy(data);
                    detailDialogPromise.show();
                });                
            }
        })
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.accountingBooks = accountingBookSvc.getAllAsync(true);
    });

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = accountingBookSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        accountingBookSvc.remove(data);
    }

    var detailDialogPromise = $modal({
        templateUrl: 'finance/accounting-books/accounting-books-detail.html',
        show: false,
        scope: $scope.$new(),
        tag: 'accountingBookDetail'
    });

    $scope.$on('modal.hide', function(e, target) {
        if (target.$options.tag === 'accountingBookDetail') {
           if ($routeParams.id) {
               $timeout(function () {
                   $location.path('/finance/accounting-books');
               }, 1);
           }
        }
    })
}]);
